import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, publishReplay, refCount, switchMap } from 'rxjs/operators';
import { UrlBuilder } from '../core';
import { CategoriesStorage, Category, CategoryNaturalKey } from '../documents';
import { DocumentsComponentBase } from './base/documents-component-base';
import { InvestigatorReportsStorage } from './investigator-reports-storage';
import { routeParams } from '../shared/route-helpers';

@Component({
    selector: 'documents-with-categories',
    template: require('./base/documents-component-base.html'),
    styles: [require('./base/documents-component-base.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentsWithChildCategoriesComponent extends DocumentsComponentBase {
    constructor(
        router: Router,
        route: ActivatedRoute,
        urlBuilder: UrlBuilder,
        categoriesStorage: CategoriesStorage,
        reportsStorage: InvestigatorReportsStorage,
    ) {
        super(router, route, urlBuilder, categoriesStorage, reportsStorage);
    }

    public createSelectedCategory(): Observable<Category> {
        return this.route.params.pipe(
            map(x => x[routeParams.childCategoryId] as CategoryNaturalKey),
            switchMap(childCategoryId => this.categoriesStorage.findCategoryById(childCategoryId)),
            publishReplay(1),
            refCount(),
        );
    }
}
